import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api';

export function ConfirmEmailPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') || '');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const e = params.get('email');
    if (e) setEmail(e);
  }, [params]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setLoading(true);
    try {
      await api.confirmSignup({ email, code });
      navigate('/login?verified=1');
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError('');
    setInfo('');
    setResending(true);
    try {
      await api.resendConfirmation(email);
      setInfo(t('confirmEmail.resent'));
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Resend failed');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>{t('confirmEmail.title')}</h1>
        <p className="login-subtitle">
          {t('confirmEmail.subtitle')}
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">{t('common.email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="code">{t('confirmEmail.codeLabel')}</label>
            <input
              id="code"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              autoComplete="one-time-code"
              inputMode="numeric"
              placeholder="123456"
            />
          </div>

          {error && <div className="form-error" role="alert">{error}</div>}
          {info && <div className="form-info" role="status">{info}</div>}

          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? t('confirmEmail.verifying') : t('confirmEmail.verify')}
          </button>

          <button type="button" onClick={handleResend} disabled={resending} className="btn-secondary">
            {resending ? t('confirmEmail.resending') : t('confirmEmail.resend')}
          </button>

          <div className="login-links">
            <Link to="/login">{t('common.backToSignIn')}</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
